import React, {useContext, useEffect, useState} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import {AuthenticationContext} from '@adv-mt/mt-context-authentication'

import {resolveSubscriptionUIState} from './util.js'
const BASE_CLASS = 'mt-NewsletterSubscription'

const NewsletterSubscription = ({pageName}) => {
  const {domain} = useContext(Context)
  const {user} = useContext(AuthenticationContext)
  const [consents, setConsents] = useState(null)
  const [isSubscribedState, setIsSubscribedState] = useState(null)
  const [emailSent, setEmailSent] = useState(false)

  useEffect(() => {
    const getConsents = async () => {
      const [, consentsResponseSuccess] = await domain.get('get_consents_user_use_case').execute()

      if (consentsResponseSuccess) setConsents(consentsResponseSuccess)
    }

    getConsents()
  }, [user]) // eslint-disable-line react-hooks/exhaustive-deps

  const sendVerificationEmail = async () => {
    const [error] = await domain.get('send_email_to_verify_user_use_case').execute()
    if (error) return console.error(error)
    setEmailSent(true)
  }

  const onAfterSubscribe = () => {
    setIsSubscribedState(true)
  }

  const uiToDisplay = resolveSubscriptionUIState({
    consents,
    domain,
    isSubscribedState,
    onAfterSubscribe,
    pageName,
    sendVerificationEmail,
    emailSent,
    user
  })

  console.log('uiID', uiToDisplay.uiID)

  return <div className={BASE_CLASS}>{uiToDisplay && uiToDisplay.render()}</div>
}

NewsletterSubscription.displayName = 'NewsletterSubscription'
NewsletterSubscription.propTypes = {
  pageName: PropTypes.string
}

export default NewsletterSubscription
